import { z } from 'zod';

import { AdvisorsGroupZod } from 'types/zod/advisors-group';

export const CreateGroupDataZod = AdvisorsGroupZod.pick({ name: true, parentGroupId: true }).and(
    AdvisorsGroupZod.pick({ admins: true }).partial(),
);
export type CreateGroupData = z.infer<typeof CreateGroupDataZod>;
